module.exports = __webpack_public_path__ + "static/media/next_arrow.def0f8d7.svg";